<ng-template #confirmationModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Votre avis nous intéresse</h4>
  </div>
  @if (!formSubmited) {
    <div class="modal-body">
      <div>
        Nous vous remercions de nous avoir fait confiance en utilisant notre outil de simulation de travaux.
        Dans le cadre d’un projet européen de recherche sur le logement, nous avons besoin de votre avis pour nous aider à
        mieux comprendre votre expérience. Il vous sera tout d’abord demandé de répondre à quelques questions pour
        vérifier
        que vous correspondez au profil recherché pour ce sondage de 4 minutes. Votre feedback est primordial.
      </div>
      <div>
        <form [formGroup]="form" class="p-2">
          <div class="mb-3">
            <label for="usageLogement" class="col-12 col-md-12 col-form-label">Vous êtes</label>
            <div class="col-12 col-md-12">
              <select class="form-control" id="usageLogement" formControlName="usageLogement">
                <option></option>
                <option value="Propriétaire occupant">Propriétaire occupant</option>
                <option value="Propriétaire non-occupant">Propriétaire non-occupant</option>
                <option value="Locataire">Locataire</option>
              </select>
            </div>
          </div>
          <div class="mb-3">
            <label for="typeLogement" class="col-12 col-md-12 col-form-label">Votre logement</label>
            <div class="col-12 col-md-12">
              <select class="form-control" id="typeLogement" formControlName="typeLogement">
                <option></option>
                <option value="Appartement">Appartement</option>
                <option value="Maison">Maison</option>
              </select>
            </div>
          </div>
          <div class="mb-3">
            <div>
              <label class="col-12 col-md-12 col-form-label">Quelles sont, selon vous, les principales difficultés liées
              aux travaux de rénovation ? </label>
              @for (item of difficulteTravauxRenovationList; track item; let i = $index) {
                <div
                  formArrayName="difficulteTravauxRenovation">
                  <div class="col-12 col-md-12 ">
                    <input [checked]="true" type="checkbox" class="me-1" id="difficulteTravauxRenovation-{{i}}"
                      [formControlName]="i">
                      <label for="difficulteTravauxRenovation-{{i}}"
                      >{{ item }}</label>
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="mb-3">
              <label for="projetTravauxPrevision" class="col-12 col-md-12 col-form-label">Avez-vous un projet de rénovation
              énergétique en cours ou prévu dans un futur proche ?</label>
              <div class="col-12 col-md-12">
                <select class="form-control" id="projetTravauxPrevision" formControlName="projetTravauxPrevision">
                  <option></option>
                  <option value="{{projetEncours}}">Oui j’ai un projet concret en cours</option>
                  <option value="{{projetFutur}}">Oui j’ai un projet prévu dans un futur
                    proche
                  </option>
                  <option value="{{projetRenseignement}}">Je me renseigne</option>
                  <option value="{{projetIndefinit}}"> Non je n’ai pas de projet défini</option>
                </select>
              </div>
            </div>
            @if (!isProjetIndefinit()) {
              <div>
                <div class="mb-3">
                  <label for="q5" class="col-12 col-md-12 col-form-label">Sur une échelle de 0 à 5 dans quelle mesure le
                    service
                    vous a-t-il semblé utile pour définir les besoins de
                  rénovation énergétique de votre logement ?</label>
                  <div class="col-12 col-md-12">
                    <select class="form-control" id="q5" formControlName="q5">
                      <option></option>
                      <option value="0">0 (Pas du tout utile)</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5 (Très utile)</option>
                    </select>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="q6" class="col-12 col-md-12 col-form-label">Les recommandations de travaux fournies par le
                    service
                  vous ont-elles semblées utiles et compréhensibles ?</label>
                  <div class="col-12 col-md-12">
                    <select class="form-control" id="q6" formControlName="q6">
                      <option></option>
                      <option value="Oui tout à fait">Oui tout à fait</option>
                      <option value="Plutôt Oui">Plutôt Oui</option>
                      <option value="Plutôt NON">Plutôt Non</option>
                      <option value="Non pas du tout">Non pas du tout</option>
                    </select>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="q7" class="col-12 col-md-12 col-form-label">Auriez-vous souhaité avoir d’autres types
                  d’informations ?</label>
                  <div class="col-12 col-md-12">
                    <select class="form-control" id="q7" formControlName="q7">
                      <option></option>
                      <option value="{{oui}}">Oui</option>
                      <option value="non">Non</option>
                    </select>
                  </div>
                </div>
                @if (isBesoinAutresInformations()) {
                  <div class="mb-3">
                    <label for="q7.2" class="col-12 col-md-12 col-form-label">Quel(s) autre(s) type(s) d’information vous
                      aurai(en)t
                    semblé utile(s) ?</label>
                    <div class="col-12 col-md-12">
                      <textarea class="form-control" id="q7.2" formControlName="q7_2"></textarea>
                    </div>
                  </div>
                }
                <div class="mb-3">
                  <label class="col-12 col-md-12 col-form-label">Parmi les fonctionnalités suivantes, lesquelles
                  avez-vous trouvées utile ?</label>
                  <div class="mb-3">
                    @for (element of projetElement; track element; let index = $index) {
                      <div class="col-12 col-md-12">
                        {{ element }}
                        <select class="form-control" id="q8.1" [formControlName]="'q8_'+(index+1)">
                          <option></option>
                          <option value="Très utile">Très utile</option>
                          <option value="Plutôt utile">Plutôt utile</option>
                          <option value="Plutôt pas utile">Plutôt pas utile</option>
                          <option value="Pas utile du tout">Pas utile du tout</option>
                          <option value="Je ne l’ai pas utilisée">Je ne l’ai pas utilisée</option>
                        </select>
                      </div>
                    }
                  </div>
                  @if (!isProjetEnCours()) {
                    <div class="mb-3">
                      <label for="q8.bis" class="col-12 col-md-12 col-form-label">Pensez-vous qu’un outil comme celui là
                        pourrait
                        vous guider ou à vous aider dans la prise de décision de lancer votre projet de travaux de rénovation
                      ?</label>
                      <div class="col-12 col-md-12">
                        <select class="form-control" id="q8.bis" formControlName="q8_bis">
                          <option></option>
                          <option value="Oui tout à fait">Oui tout à fait</option>
                          <option value="Plutôt Oui">Plutôt Oui</option>
                          <option value="Plutôt Non">Plutôt Non</option>
                          <option value="Non pas du tout">Non pas du tout</option>
                        </select>
                      </div>
                    </div>
                  }
                </div>
                <div class="mb-3">
                  <label for="q9" class="col-12 col-md-12 col-form-label">Quelle autre thématique de travaux aimeriez-vous
                  trouver dans ce nouveau service ?</label>
                  <div class="col-12 col-md-12">
                    <select class="form-control" id="q9" formControlName="q9">
                      <option value="Confort">Confort</option>
                      <option value="Adaptation au vieillissement">Adaptation au vieillissement</option>
                      <option value="Adaptation au handicap">Adaptation au handicap</option>
                      <option value="Sécurité">Sécurité</option>
                      <option value="Adaptation au changement climatique">Adaptation au changement climatique</option>
                      <option value="Isolation acoustique">Isolation acoustique</option>
                      <option value="Santé">Santé</option>
                      <option value="{{autre}}">Autre</option>
                    </select>
                  </div>
                  @if (isAutre()) {
                    <div class="col-12 col-md-12">
                      <label for="q9" class="col-12 col-md-12 col-form-label">Précisez</label>
                      <textarea class="form-control" id="q9.2" formControlName="q9_2"></textarea>
                    </div>
                  }
                </div>
                <div class="mb-3">
                  <label for="q10" class="col-12 col-md-12 col-form-label">Connaissez-vous d’autres outils similaires de
                  diagnostic de rénovation ?</label>
                  <div class="col-12 col-md-12">
                    <select class="form-control" id="q10" formControlName="q10">
                      <option></option>
                      <option value="{{oui}}">Oui</option>
                      <option value="non">Non</option>
                    </select>
                  </div>
                </div>
                @if (isAutresOutils()) {
                  <div class="mb-3">
                    <label for="q10.1" class="col-12 col-md-12 col-form-label"> lesquels ? </label>
                    <div class="col-12 col-md-12">
                      <textarea class="form-control" id="q10.1" formControlName="q10_1"></textarea>
                    </div>
                  </div>
                }
                @if (isAutresOutils()) {
                  <div class="mb-3">
                    <label for="q10.2" class="col-12 col-md-12 col-form-label"> comment évalueriez-vous CLEA par rapport aux
                    autres ? </label>
                    <div class="col-12 col-md-12">
                      <select class="form-control" id="q10.2" formControlName="q10_2">
                        <option></option>
                        <option value="Supérieur">Supérieur</option>
                        <option value="Equivalent">Equivalent</option>
                        <option value="Inférieur">Inférieur</option>
                      </select>
                    </div>
                  </div>
                }
                <div class="mb-3">
                  <label for="q12" class="col-12 col-md-12 col-form-label">Le fait que QUALITEL soit une association est-il
                  important pour vous dans l’utilisation de ce service ? </label>
                  <div class="col-12 col-md-12">
                    <select class="form-control" id="q12" formControlName="q12">
                      <option></option>
                      <option value="Oui tout à fait">Oui tout à fait</option>
                      <option value="Plutôt Oui">Plutôt Oui</option>
                      <option value="Plutôt NON">Plutôt Non</option>
                      <option value="Non pas du tout">Non pas du tout</option>
                    </select>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="q13" class="col-12 col-md-12 col-form-label">A combien estimez-vous le prix d’un tel service
                  ?</label>
                  <div class="col-12 col-md-12">
                    <select class="form-control" id="q13" formControlName="q13">
                      <option></option>
                      <option value="10 € par projet"> 10 € par projet</option>
                      <option value="Entre 11 et 20 € par projet">Entre 11 et 20 € par projet</option>
                      <option value="Entre 20 et 50 € par projet">Entre 20 et 50 € par projet</option>
                      <option value="Je n’ai pas d’idée de prix"> Je n’ai pas d’idée de prix</option>
                    </select>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="q14" class="col-12 col-md-12 col-form-label">Accepteriez-vous d'être recontacté par téléphone
                    pour
                  nous permettre de recueillir plus d’informations et d’améliorer l’outil</label>
                  <div class="col-12 col-md-12">
                    <select class="form-control" id="q14" formControlName="q14">
                      <option></option>
                      <option value="{{oui}}">Oui</option>
                      <option value="non">Non</option>
                    </select>
                  </div>
                </div>
                @if (isContactezMoi()) {
                  <div class="mb-3">
                    <label for="q14.2" class="col-12 col-md-12 col-form-label"> Merci de nous laisser vos coordonnées </label>
                    <label for="q14.2" class="col-12 col-md-12 col-form-label"> Téléphone</label>
                    <div class="col-12 col-md-12">
                      <input type="tel" class="form-control" id="q14.2" formControlName="q14_2"/>
                      @if (form.controls.q14_2.invalid && form.controls.q14_2.touched) {
                        <div class="text-danger">
                          @if (form.controls.q14_2.errors?.pattern) {
                            <small>Numéro invalide. Ex: 0612345678</small>
                          }
                        </div>
                      }
                    </div>
                    <label for="q14.3" class="col-12 col-md-12 col-form-label"> Email </label>
                    <div class="col-12 col-md-12">
                      <input type="email" class="form-control" id="q14.3" formControlName="q14_3"/>
                      @if (form.controls.q14_3.invalid && form.controls.q14_3.touched) {
                        <div class="text-danger">
                          @if (form.controls.q14_3.errors?.email) {
                            <small>Format d'email invalide.</small>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            <div class="row">
              <div class="mb-3 col-12 text-end">
                <button type="button" class="btn btn-light me-1" (click)="close()">Répondre ultérieurement</button>
                <button type="button" class="btn btn-danger me-1" (click)="skipPoll()">Ne plus afficher</button>
                <button type="button" class="btn btn-blue me-1" [disabled]="!formValid" (click)="submit()"> Envoyer ma
                  réponse
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    }
    @if (formSubmited) {
      <div>
        <div class="modal-body">
          Nous vous remercions pour votre participation.
        </div>
        <div class="row">
          <div class="mb-3 col-12 text-end">
            <button type="button" class="btn btn-light me-1" (click)="close()">Fermer</button>
          </div>
        </div>
      </div>
    }
  </ng-template>
